import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const targetId = hash.replace('#', '');
      const element = document.getElementById(targetId);
      
      const performScroll = (val: HTMLElement) => {
        // Header height offset (80px) + custom padding (16px) = 96px
        const headerOffset = 96;
        
        // Defer reading layout properties to the next animation frame to prevent synchronous layout thrashing / forced reflows.
        requestAnimationFrame(() => {
          const bodyRect = document.body.getBoundingClientRect().top;
          const elementRect = val.getBoundingClientRect().top;
          const elementPosition = elementRect - bodyRect;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition >= 0 ? offsetPosition : 0,
            behavior: 'smooth'
          });
        });
      };

      if (element) {
        // Defer scroll operation until next browser paint loop completes
        const timer = setTimeout(() => {
          performScroll(element);
        }, 50);
        return () => clearTimeout(timer);
      } else {
        const timer = setTimeout(() => {
          const retryElement = document.getElementById(targetId);
          if (retryElement) {
            performScroll(retryElement);
          }
        }, 150);
        return () => clearTimeout(timer);
      }
    } else {
      // Instant scroll to the absolute top of the page on route/path changes
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
